import { ReactElement, useState } from 'react';

import { IconAngleRight } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';

import { ONBOARDING_PATHS } from '../../../constants';

export const OnboardingStepItem = ({
    title,
    modal,
    link
}: {
    title: ReactElement;
    modal?: ReactElement;
    link?: string;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <NEW_IwLink
            to={{ pathname: link ? link : ONBOARDING_PATHS.ONBOARDING_CHECKS }}
            className="w-full flex-row !justify-between border-b-[1px] border-b-secondary-90 py-l text-left"
        >
            <Button onClick={() => setIsModalOpen(true)} variant="tertiary">
                <Text className="my-auto text-m font-med text-primary-40">
                    {title}
                </Text>
                <IconAngleRight />
            </Button>

            {modal && (
                <Modal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    closeIcon
                >
                    {modal}
                </Modal>
            )}
        </NEW_IwLink>
    );
};
